import React from 'react';

import { ReactComponent as SnapIcon } from 'icons/snap.svg';

import { analytics } from '../../firebase';
import { logEvent } from 'firebase/analytics';

export default function RedirectButton() {
  const onRedirect = () => {
    console.log('sending webCollectVibeDownload_button event');
    try {
      logEvent(analytics, 'webCollectVibeDownload_button');
    } catch (err) {
      console.error('Firebase analytics error:', err);
    }

    window.location.href = 'https://onvi.be/u/collectVibes';
  };

  return (
    <div
      className="redirect-button link"
      onClick={onRedirect}
    >
      <p className="m5 semibold">Collect good vibes</p>
      <SnapIcon />
    </div>
  );
}